<template>
  <b-modal
    ref="view-teacher-notification"
    id="view-teacher-notification"
    hide-header
    hide-footer
    centered
    @shown="markAsRead"
  >
    <b-row v-if="notification">
      <b-col md="12">
        <h4 class="purple mb-4">Detalhes da notificação</h4>
      </b-col>

      <b-col md="12" class="mt-2">
        <b-form-group label="Destinatário">
          <b-form-input
            type="text"
            :value="teacher && teacher.User ? teacher.User.name : ''"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6" class="mt-2">
        <b-form-group label="Data">
          <b-form-input
            type="text"
            :value="formatDate(notification.created_at)"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6" class="mt-2">
        <b-form-group label="Status">
          <b-form-input
            type="text"
            :value="statusLabel"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6" class="mt-2">
        <b-form-group label="Ciclo">
          <b-form-input
            type="text"
            :value="notification.Cycle ? notification.Cycle.name : ''"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6" class="mt-2">
        <b-form-group label="Aluno">
          <b-form-input
            type="text"
            :value="notification.Student ? notification.Student.User.name : ''"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6" class="mt-2" v-if="notification.deadline">
        <b-form-group label="Data limite">
          <b-form-input
            type="text"
            :value="formatDeadLine(notification.deadline)"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6" class="mt-2">
        <b-form-group label="Área do Conhecimento">
          <b-form-input
            type="text"
            :value="notification.Subject ? notification.Subject.designation : ''"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="12" class="mt-2">
        <b-form-group label="Mensagem">
          <b-form-textarea
            :value="notification.message"
            rows="4"
            disabled
          ></b-form-textarea>
        </b-form-group>
      </b-col>


    </b-row>

    <b-row class="mt-5" v-if="notification">
      <b-col v-if="canManage">
        <b-button class="btn large outline" @click="requestDelete"
          >Excluir</b-button
        >
      </b-col>
      <b-col v-if="canManage" class="text-right">
        <b-button class="btn large outline" @click="requestEdit"
          >Editar</b-button
        >
      </b-col>
      <b-col class="text-right">
        <b-button class="btn large blue" @click="close">Fechar</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import moment from "moment-timezone";
import { mapGetters } from "vuex";
import TeacherNotificationsService from "@/services/teacherNotifications.service";

export default {
  name: "",

  props: {
    teacher: {
      type: Object,
      default: null,
    },
    notification: {
      type: Object,
      default: null,
    },
  },

  computed: {
    ...mapGetters({
      currentUser: "auth/getAuthData",
    }),

    canManage() {
      if (!this.notification || !this.notification.Creator || !this.currentUser) {
        return false;
      }

      return (
        this.notification.Creator.id === this.currentUser.id &&
        !(this.notification.readed_at > 0) &&
        !(this.notification.resolved_at > 0)
      );
    },

    statusLabel() {
      if (!this.notification) {
        return "";
      }

      if (this.notification.resolved_at > 0) {
        return `Resolvida em ${this.formatDate(this.notification.resolved_at)}`;
      }

      if (this.notification.readed_at > 0) {
        return `Lida em ${this.formatDate(this.notification.readed_at)}`;
      }

      return "Pendente";
    },
  },

  methods: {
    close() {
      this.$refs["view-teacher-notification"].hide();
    },

    async markAsRead() {
      if (
        !this.notification ||
        this.notification.resolved_at === 0 ||
        this.notification.user_readed_at > 0
      ) {
        return;
      }

      const response = await TeacherNotificationsService.markRead(
        this.notification.id
      );
      this.notification.user_readed_at = response.data.user_readed_at;
    },

    formatDate(date) {
      return moment.tz(date, "America/Sao_Paulo").format("DD/MM/YYYY HH:mm");
    },

    formatDeadLine(date) {
      return moment.tz(date, 'YYYY-MM-DD').format("DD/MM/YYYY");
    },

    requestEdit() {
      this.$emit("edit", this.notification);
      this.close();
    },

    requestDelete() {
      this.$swal
        .fire({
          title: "Excluir notificação?",
          text: "Essa ação não poderá ser desfeita.",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, excluir!",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteNotification();
          }
        });
    },

    async deleteNotification() {
      try {
        await TeacherNotificationsService.remove(this.notification.id);
        this.$emit("deleted", this.notification.id);
        this.close();
      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "Não foi possível excluir a notificação.";

        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: message,
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/variables.scss";

div#view-teacher-notification {
  .modal-dialog {
    max-width: 820px;
    .modal-content {
      background-color: $grey2;
      border: 0;
      border-radius: 0;
      .modal-body {
        padding: 60px;
      }
    }
  }
}
</style>
